/**
 * A real instant — when an email went out, when a switch was flipped — in the
 * reader's own zone, to the minute: "26 Sept 2026, 10:34 pm".
 *
 * Only for instants. An event's times are wall clock at the venue and must never
 * go through this; see `eventTime.ts`.
 */
export function instantLabel(at: string): string {
  return new Date(at).toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}
